var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useSetAtom } from 'jotai';
import { accessTokenAtom, ANONYMOUS_USER_TEMPLATE, useMe } from '@/atoms/Auth';
import useAppComponents from '@/hooks/useAppComponents';
/**
 * 익명(비회원) 계정을 발행해 토큰/유저정보를 세팅한다.
 * LoginScreen "비회원 둘러보기"와 web 전역 무로그인 부트스트랩(App.tsx)이 공유한다.
 */
export function useEnsureAnonymousUser() {
    const { api } = useAppComponents();
    const setAccessToken = useSetAtom(accessTokenAtom);
    const { setUserInfo } = useMe();
    return () => __awaiter(this, void 0, void 0, function* () {
        const res = yield api.createAnonymousUserPost();
        const { authTokens, userId } = res.data;
        const anonymousUser = Object.assign(Object.assign({}, ANONYMOUS_USER_TEMPLATE), { id: userId });
        setAccessToken(authTokens.accessToken);
        yield setUserInfo(anonymousUser);
        return authTokens.accessToken;
    });
}
